import React from 'react'

export default function Segments({ account, store }) {
  return <div>Segments Container</div>
}
